import { call, put, take, takeEvery } from 'redux-saga/effects';
import { GlobalAction, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { DashboardActions } from '../dashboard.actions';

export function* watchShowDashboardModal() {
  yield takeEvery(
    DashboardActions.REQUEST_DASHBOARD_MODAL,
    safeSaga(openModal, App.SHOP_DASHBOARD),
  );
}

export function* openModal(action: AnyAction) {
  const modalActions: Record<string, AnyAction> = {
    [DashboardActions.STANDALONE_PRODUKT_MODAL_OPEN]:
      new DashboardActions().standaloneProduktDialogOpen(action.payload.actionPayload),
    [DashboardActions.STANDALONE_EINSCHLIESSEN_MODAL_OPEN]:
      new DashboardActions().standaloneEinschliessenDialogOpen(action.payload.actionPayload),
    [DashboardActions.RS_ZUSAMMENFUEHREN_MODAL_OPEN]:
      new DashboardActions().rsZusammenfuehrenModalOpen(action.payload.actionPayload),
    [DashboardActions.EHV_MODAL_OPEN]: new DashboardActions().ehvDialogOpen(
      action.payload.actionPayload,
    ),
  };
  const functionToCall = modalActions[action.payload.modalActionType];

  const globalPut = GlobalPut.getInstance();
  yield call([globalPut, globalPut.put], new GlobalActions().globalModalStatusRequested());

  const globalModalOpen: GlobalAction<boolean> = yield take(
    GlobalActions.SHOP_MODAL_STATUS_RECIEVED,
  );

  if (globalModalOpen.payload) {
    yield take(GlobalActions.CLOSE_MODAL);
  }
  yield put(functionToCall);
}
